import { Box, IconButton, Paper, Popover, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Notifications as NotificationsIcon } from "@material-ui/icons";
import CloseIcon from "../../icons/close-icon";
import React, { useState } from "react";
import { useNavigate } from "/src/hooks/navigation";
// theme
import theme from "../../theme";
import { getConsultationStatusFromStatus } from "./../../redux/reducers";
import NotificationItem from "./notification-item";
import { Trans } from "@lingui/macro";

const useStyles = makeStyles((theme) => ({
  notification: {
    color: ({ isOwner }) =>
      isOwner ? theme.palette.white : theme.palette.primary.main,
  },
  ring: {
    animation: `$ring 3s ${theme.transitions.easing.easeInOut}`,
  },
  "@keyframes ring": {
    "0%": { transform: "rotate(0)" },
    "1%": { transform: "rotate(30deg)" },
    "3%": { transform: "rotate(-28deg)" },
    "5%": { transform: "rotate(34deg)" },
    "7%": { transform: "rotate(-32deg)" },
    "9%": { transform: "rotate(30deg)" },
    "11%": { transform: "rotate(-28deg)" },
    "13%": { transform: "rotate(26deg)" },
    "15%": { transform: "rotate(-24deg)" },
    "17%": { transform: "rotate(22deg)" },
    "19%": { transform: "rotate(-20deg)" },
    "21%": { transform: "rotate(18deg)" },
    "23%": { transform: "rotate(-16deg)" },
    "25%": { transform: "rotate(14deg)" },
    "27%": { transform: "rotate(-12deg)" },
    "29%": { transform: "rotate(10deg)" },
    "31%": { transform: "rotate(-8deg)" },
    "33%": { transform: "rotate(6deg)" },
    "35%": { transform: "rotate(-4deg)" },
    "37%": { transform: "rotate(2deg)" },
    "39%": { transform: "rotate(-1deg)" },
    "41%": { transform: "rotate(1deg)" },
    "43%": { transform: "rotate(0)" },
    "100%": { transform: "rotate(0)" },
  },
  loadingCircle: {
    marginLeft: 25,
    marginRight: 10,
  },
  popover: {
    maxHeight: 400,
  },
  paper: {
    padding: theme.spacing(1),
  },
  sidebar: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxHeight: 400,
    boxShadow: "none",
  },
  title: {
    color: theme.palette.secondary.main,
    textDecoration: "underline",
  },
  item: {
    display: "flex",
  },
  notificationButton: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
  },
}));

const NotificationsComponent = ({ notifications = [], user = {}, status }) => {
  const classes = useStyles({
    ...theme,
    isOwner: user.isOwner,
    notifications,
  });
  const { navigate } = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const divRef = React.useRef();

  const handleClick = () => {
    setAnchorEl(divRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickNotification = (status, bookingId) => {
    if (user.isOwner) {
      navigate(`/administrator/requests/${bookingId}`);
    } else {
      const consultationStatus = getConsultationStatusFromStatus(status);
      navigate(`/tenant/${consultationStatus}/chat/${bookingId}`);
    }
    handleClose();
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <div ref={divRef}>
        <IconButton
          className={classes.notificationButton}
          color="inherit"
          onClick={handleClick}
        >
          <NotificationsIcon
            className={`${classes.notification} ${
              notifications.length > 0 ? classes.ring : ""
            }`}
          />
          <Typography variant="body1">| {notifications.length}</Typography>
        </IconButton>
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className={classes.popover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableScrollLock
      >
        <Paper className={classes.sidebar} elevation={5} square>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexDirection="row"
            width="100%"
            mb={1}
          >
            <Typography variant="h6" className={classes.title}>
              <Trans>Notificaciones</Trans>
            </Typography>
            <Box onClick={handleClose} style={{ cursor: "pointer" }}>
              <CloseIcon width="12px" height="12px" />
            </Box>
          </Box>
          <Box mt={1} mb={1}>
            {/** notifications has all the bookings with notifiations */}
            {notifications.map((n) => (
              <NotificationItem
                bookingId={n.booking_id}
                status={n.status}
                spaceTitle={n.space_title}
                projectName={n.project_name}
                key={n.booking_id}
                onClick={handleClickNotification}
              />
            ))}
            {!notifications.length && (
              <Typography variant="body1">
                <Trans>No tienes nuevas notificaciones</Trans>.
              </Typography>
            )}
          </Box>
        </Paper>
      </Popover>
    </>
  );
};

export default NotificationsComponent;
